import React from 'react';
import { Navigate } from 'react-router-dom';
import { getUser, setReturnURL} from '../../../utils/commonfunction';
import { ROLE } from "../../../utils/Constants";

const DoctorPrivateRoute = ({ component: Component }) => {
    const userData = getUser(ROLE.DOCTOR)
    return (
        <>
            {(function(){
                if(Object.keys(userData).length && userData.token && userData.role == ROLE.DOCTOR){
                    return <Component/>
                }else{
                    setReturnURL(ROLE.DOCTOR);
                    return <Navigate to="/doctor/login" />;
                }
            })()}
        </>
    )
}

export default DoctorPrivateRoute;
